import '../styles/Footer.css';

function Footer() {
  return (
    <div id='footer'>
      <footer class='p footer mt-auto py-3'>
        <div class='p container'>
          <div className='p container-fluid'>
           

            <section class='mb-4'>
              <a
                class='btn btn-outline-dark btn-floating m-1 rounded-circle'
                href='https://www.linkedin.com/in/hardik-agarwal-744a09205/'
                role='button'>
                <i class='fab fa-linkedin-in'></i>
              </a>

              <a
                class='btn btn-outline-dark btn-floating m-1 rounded-circle'
                href='mailto:hardikag17@gmail.com'
                role='button'>
                <i class='fas fa-envelope'></i>
              </a>

              <a
                class='btn btn-outline-dark btn-floating m-1 rounded-circle'
                href='https://twitter.com/hardikag17'
                role='button'>
                <i class='fab fa-twitter'></i>
              </a>

              <a
                class='btn btn-outline-dark btn-floating m-1 rounded-circle'
                href='https://www.instagram.com/hardikagarwal843'
                role='button'>
                <i class='fab fa-instagram'></i>
              </a>
              <a
                class='btn btn-outline-dark btn-floating m-1 rounded-circle'
                href='https://github.com/Hardikag17'
                role='button'>
                <i class='fab fa-github'></i>
              </a>
            </section>
          </div>
        </div>
        <div className='footer-text'><a href = "#navbar">⇧ Back to top</a></div>
      </footer>
    </div>
  );
}

export default Footer;
